import { useLang } from '@/i18n';
import styles from './index.module.scss';
import { useEffect, useState } from 'react';
import EcoImg from 'eco-design/base/eco-img';

let titleSceneL: any = null;
const L = () => {
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (titleSceneL) {
                    AniContainer.removeScene(titleSceneL);
                    titleSceneL = null;
                }

                titleSceneL = AniContainer.create({
                    triggerElement: '.dpu-detail-L .dpu-L-box',
                    triggerHook: 1,
                    offset: '50%',
                    duration: 200,
                    onEnter: () => {
                        setTextEnter(true);
                    },
                });
            };
            resizeAni();
            return () => {
                if (titleSceneL) {
                    AniContainer.removeScene(titleSceneL);
                    titleSceneL = null;
                }
            };
        }
    }, []);
    return (
        <section className={`dpu-detail-L dpu-detail-section ${styles.dpuDetailL}`}>
            <div className={`dpu-L-box ${textEnter ? 'enter' : ''}`}>
                <p className='title'>
                    <EcoImg pc='https://websiteoss.ecoflow.com/upload/image/1773199693103/7-pc-1.png'></EcoImg>
                    {t('secL_title')}</p>
                <p className='desc'>{t('secL_desc')}</p>
                <EcoImg className='L-box-img' pc='https://websiteoss.ecoflow.com/upload/image/1773199692873/7-pc-2.png' pad='https://websiteoss.ecoflow.com/upload/image/1773199692667/7-m-1.png' h5='https://websiteoss.ecoflow.com/upload/image/1773199692667/7-m-1.png'></EcoImg>

                <p className="tips">{t('secL_tips')}</p>
            </div>
        </section>
    );
};

export default L;
